var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 5.5C9.875 5.82812 9.61719 6.0625 9.3125 6.0625H5.5625V9.8125C5.5625 10.1406 5.30469 10.3984 5 10.3984C4.67188 10.3984 4.4375 10.1406 4.4375 9.8125V6.0625H0.6875C0.359375 6.0625 0.125 5.82812 0.125 5.52344C0.125 5.19531 0.359375 4.9375 0.6875 4.9375H4.4375V1.1875C4.4375 0.882812 4.67188 0.648438 5 0.648438C5.30469 0.648438 5.5625 0.882812 5.5625 1.1875V4.9375H9.3125C9.61719 4.9375 9.875 5.19531 9.875 5.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.127fc3a274e86c1cce40cd524b2bd2cc.svg";
export { ForwardRef as ReactComponent };